<div class="bar-container" #under_bar>
    <div class="categories-list" [lang]="translate.currentLang">
        <div class="megamenu">
            <div class="megamenu__body">
                <div class="main-title">
                    {{'categories'|translate}}
                </div>
                <ng-container *ngFor="let category of categories">
                    <a appclick [routerLink]="['/',currentLang,'category', category?.seo?.slug]" class="category-link"
                        [class.active]="currentPage == category?.seo?.slug" (click)="categoryChange(category)">
                        <div class="icon" *ngIf="category.icon"><img [src]="category.icon.url"></div>
                        <div class="title">{{translateHelper.localize(category.name)}}</div>
                    </a>
                </ng-container>
            </div>
        </div>
    </div>
</div>